export default __webpack_public_path__ + "static/media/BA10.40c273ce.jpg";